import * as PIXI from "pixi";
import Cs from "../utils/Cs";
import Timer from "../utils/Timer";
import Bouncer from "./Bouncer";
import Game from "./Game";

import MTSprite from "./MTSprite";

export default class Phys<T = {}> extends MTSprite<T> {
  flOrient: boolean = false;

  //   ray: float | null = null;
  weight: null | number = null;
  frict: number;
  vx: number;
  vy: number;
  vr: number | null = null;
  bouncer: Bouncer | null = null;

  constructor(game: Game, mc: PIXI.animate.MovieClip) {
    super(game, mc);
    this.frict = 0.95;
    this.vx = 0;
    this.vy = 0;
  }

  update() {
    super.update();

    if (this.vr != null) {
      this.root.rotation += this.vr * Timer.tmod;
    }

    if (this.weight != null) {
      this.vy += this.weight * Timer.tmod;
    }

    if (this.frict != null) {
      let f = Math.pow(this.frict, Timer.tmod);
      this.vx *= f;
      this.vy *= f;
    }
    if (this.bouncer != null) {
      this.bouncer.update();
    } else {
      this.x += this.vx * Timer.tmod;
      this.y += this.vy * Timer.tmod;
    }
    if (this.flOrient) {
      this.root.angle = Math.atan2(this.vy, this.vx);
    }
  }

  removeBouncer() {
    if (this.bouncer) {
      this.x = this.bouncer.px + this.bouncer.ox;
      this.y = this.bouncer.py + this.bouncer.oy;
      this.bouncer?.removeAllListeners();
      this.bouncer = null;
    }
  }

  updatePos() {
    super.updatePos();
    if (this.bouncer != null) {
      this.bouncer.px = Math.floor(this.x);
      this.bouncer.py = Math.floor(this.y);
      this.bouncer.ox = this.x - this.bouncer.px;
      this.bouncer.oy = this.y - this.bouncer.py;
    }
  }

  speedToward(o: { x: number; y: number }, c: number, lim: number) {
    let dx = o.x - this.x;
    let dy = o.y - this.y;
    this.vx += Cs.mm(-lim, dx * c, lim);
    this.vy += Cs.mm(-lim, dy * c, lim);
  }
}
